import { render } from "./App.vue?vue&type=template&id=522f5213"
const script = {}

import "./App.vue?vue&type=style&index=0&id=522f5213&lang=css"
script.render = render

export default script